import { blogsData, type Blog } from "@/data/blog";
import { BlogEventCard } from "@/components/common/cards/BlogEventsCard";
import { useState, RefObject } from "react";

interface BlogsProps {
  gridRef: RefObject<HTMLElement>;
}

export const Blogs = ({ gridRef }: BlogsProps) => {
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 6;

  // Trier les blogs par date décroissante (du plus récent au plus ancien)
  const sortedBlogs = [...blogsData].sort((a, b) => {
    const dateA = new Date(a.date).getTime();
    const dateB = new Date(b.date).getTime();
    return dateB - dateA;
  });

  const totalPages = Math.ceil(sortedBlogs.length / blogsPerPage);
  const startIndex = (currentPage - 1) * blogsPerPage;
  const currentBlogs = sortedBlogs.slice(startIndex, startIndex + blogsPerPage);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    gridRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="flex flex-col gap-12">
      {currentBlogs.length > 0 ? (
        <>
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
            {currentBlogs.map((blog) => (
              <BlogEventCard
                {...blog}
                key={blog.id}
                variant="secondary"
                imageBanner={blog.imageBanner}
                type="Blog"
              />
            ))}
          </div>

          {totalPages > 1 && (
            <div className="mt-8 flex justify-center gap-2">
              {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                (page) => (
                  <button
                    key={page}
                    onClick={() => handlePageChange(page)}
                    className={`px-4 py-2 ${
                      currentPage === page
                        ? "bg-white text-black"
                        : "border-2 border-white bg-transparent text-white hover:bg-black/50"
                    }`}
                  >
                    {page}
                  </button>
                ),
              )}
            </div>
          )}
        </>
      ) : (
        <p className="text-center text-gray-500">
          Aucun article de blog pour le moment.
        </p>
      )}
    </section>
  );
};
